import { useState } from 'react';

// Hook — manages snackbar state and all actions for ContentPanelHeader
export function useContentPanelActions(entry) {
    const [snackOpen, setSnackOpen] = useState(false);
    const [snackMessage, setSnackMessage] = useState('');

    const showSnack = (message) => {
        setSnackMessage(message);
        setSnackOpen(true);
    };

    const handleCopy = async () => {
        if (!entry?.body) return;
        try {
            await navigator.clipboard.writeText(entry.body);
            showSnack('Copied to clipboard');
        } catch {
            showSnack('Copy failed');
        }
    };

    const handleEmail = () => {
        if (!entry) return;
        // Open mailto with entry title as subject and body as mail body
        const subject = encodeURIComponent(`[Jerny] ${entry.title}`);
        const body = encodeURIComponent(`Type: ${entry.type}\n\n${entry.body}`);
        window.open(`mailto:?subject=${subject}&body=${body}`);
    };

    const handleDownload = () => {
        showSnack('Download CSV — coming soon');
    };

    const handleShare = () => {
        showSnack('Share with Jerny users — coming soon');
    };

    const handleCloseSnack = () => setSnackOpen(false);

    return {
        snackOpen,
        snackMessage,
        showSnack,
        handleCopy,
        handleEmail,
        handleDownload,
        handleShare,
        handleCloseSnack,
    };
}
